import { all, fork } from "redux-saga/effects";

import LayoutSaga from "./layout/saga";
// import calendarSaga from "./calendar/saga";
// import chatSaga from "./chat/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    // fork(calendarSaga),
    // fork(chatSaga),
  ]);
}
